import axios from 'axios'
import APIService from '@/api/services/APIService/APIServiceImpl'
import PriceServiceV1 from '@/api/services/PriceService/PriceServiceV1'
import SeasonEnum from '@/config/SeasonEnum'

import { PriceDTO, PriceResponseDTO } from "../../../../../requests-module"

export default class PriceServiceV1Impl
    extends APIService
    implements PriceServiceV1 {
    constructor() {
        const serviceUrl = `https://api.travelski.com/price/price` // TODO switch url
        super(serviceUrl)
    }

    async postPrice(dto: PriceDTO): Promise<PriceResponseDTO> {
        const params = {}
        const headers = {
            ...this.getDefaultHeaders(),
        }
        const url = `${this.getServiceUrl()}/options/accommodations` // TODO use this later
        const { data } = await axios.post(url, JSON.stringify(dto), {
            params,
            headers,
        })
        return data
    }

}